module.exports = __webpack_public_path__ + "img/pc_text_bg.92948c6.webp";